import type { AiParams } from "./ai-pilot";

export type AiDifficulty = "easy" | "normal" | "hard";

/**
 * Difficulty presets. Measured over AI-vs-AI matches (tests/unit/sim/ai.test.ts): each level
 * beats the one below by a clear margin, and none of them crash into planets.
 */
export const AI_DIFFICULTY: Record<AiDifficulty, AiParams> = {
	easy: { thinkInterval: 12, aimError: 0.25, lookahead: 45, fireTolerance: 0.12, engageRange: 700 },
	normal: { thinkInterval: 6, aimError: 0.1, lookahead: 90, fireTolerance: 0.08, engageRange: 600 },
	hard: { thinkInterval: 2, aimError: 0.03, lookahead: 150, fireTolerance: 0.05, engageRange: 500 },
};
